import { TableViewStore, BaseListViewStore, DateRangeQueryPickerStore, BaasicDropdownStore } from "core/stores";
import { ScheduleService } from "application/schedule/services";
import {CorporateService} from 'application/corporate/services';
import { resolveColumns } from "application/facility/util/resolveColumns";
import _ from 'lodash';
import { action, observable } from "mobx";
import applicationContext from 'core/utils/applicationContext';
import {GridBooleanCell} from 'core/components';
import { FacilityService } from "application/facility/services";
import moment from 'moment';
import { toUTCDate } from "core/utils";

@applicationContext
class MissingInventoryFlagReportListViewStore extends BaseListViewStore {
	@observable accessor downloadUrl = null;
	constructor(rootStore) {
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        super(rootStore, {
			autoInit: true,
			name: 'missing-inventory-flag-report',
			routes: {

			},
			actions: () => {
				return {
					find: async params => {
						const typeResponse = await scheduleService.getTypes();
						const orderingType = typeResponse && typeResponse.item.find(t => t.abrv == "ordering");
						if(this.queryUtility.filter.dateOfServiceTo === undefined)
						{
							var date = new Date();
							const format = "YYYY-MM-DD";
							var formatedDate = moment(date).format(format);
							params.dateOfServiceTo = formatedDate;
						}
						params.isMissingReport = true;
						params.calendarTypeId = orderingType.id;
						this.queryUtility.filter.isMissingReport = true;
						const response = await scheduleService.find({...params, embed:"Facility,Facility.Corporate_"});
						const responseData = _.extend(response.data,
						{
							item: response.data.item.map(i => {
								return {
									id: i.id,
									facility: i.facility && i.facility.name,
									corporate: i.facility && i.facility.corporate_ && i.facility.corporate_.name,
									dateOfService: i.dateOfService && toUTCDate(i.dateOfService),
									missingInventoryCount: i.missingInventoryCount
								};
							})
						});
						this.onFindSuccess(params);
						return responseData;
					}
				};
			},
		});

        this.scheduleService = scheduleService;
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const corporateService = new CorporateService(rootStore.application.baasic.apiClient);
        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();
        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: resolveColumns([
					{
						key: 'facility',
						title: "MISSING_INVENTORY_FLAG_REPORT.LIST.COLUMNS.FACILITY_NAME"
					},
					{
						key: 'corporate',
						title: "MISSING_INVENTORY_FLAG_REPORT.LIST.COLUMNS.CORPORATE"
					},
					{
						key: 'dateOfService',
						title: "MISSING_INVENTORY_FLAG_REPORT.LIST.COLUMNS.DATE_OF_SERVICE",
						width: 250
					},
					{
						key: 'missingInventoryCount',
						title: "MISSING_INVENTORY_FLAG_REPORT.LIST.COLUMNS.MISSING_INVENTORY_COUNT",
						cell: GridBooleanCell,
						displayFaultyValue: false,
						width: 250
					},			
				]),
				actions: {
				},
			})
		);

        this.queryUtility.onResetFilter = ()=>{
            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = "";

            this.corporateStore.setValue(null);    
            this.corporateStore.filterTerm = "";

           this.rangeQueryPickerStore.reset();
        }

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
                const response = await facilityService.find({ isActive: true, searchQuery: term, rpp: 100 });
				
				return response.data.item;          
             }
		});

        this.corporateStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await corporateService.find({ isActive: true, searchQuery: term, rpp: 100 });             
                return response.data.item;          
             }
        });
    }

	@action.bound
	onFindSuccess(params) {
        this.downloadUrl = `${this.scheduleService.getDownloadUrl(params)}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`;
    }

}

export default MissingInventoryFlagReportListViewStore;